import styled, { css } from '@react-pdf/styled-components';
import { fonts } from 'stylesheets';

export const Page = styled.Page`
  padding: 0 0 0 0;
  background-color: white;  
  font-family: ${fonts.primary};
`;

const boxShadow = css`
  background-color: #000000;
  opacity: 0.05;
`;

export const Section = styled.View`
  width: 100%;  
  padding: 5px 15px 5px 15px;
  height: ${props => props.height || 'auto'};
  background: ${props => props.background || 'transparent'};
`;

export const ContainerRadius = styled.View`
  border-radius: 4px;
  background: white;
`;

export const TextCustom = styled.Text`
  font-weight: ${props => (props.bold ? 'bold' : 'normal')};
  font-size: ${props => props.size || '12px'};  
  color: ${props => props.color || '#565656'};
  margin: ${props => props.margin || '0 0 0 0'};
  line-height:1.5;
`;

export const Line = styled.View`
  width: ${props => (props.vertical ? '1px' : '100%')};
  height: ${props => (props.vertical ? '100%' : '1px')};
  margin: ${props => props.margin || '0 0 0 0'};
  border: 1px solid #E9E9E9;
`;

export const FlexContainer = styled.View`
  display: inline;
  flex-direction: ${props => (props.row ? 'row' : 'column')};
`;
